import { useSelector } from 'react-redux';
import { useStores } from 'src/common/providers';
import { useRouteProps } from 'src/common/providers/RoutePropsProvider';
import { playerStatuses } from '../../constants/playerStatuses';
import { selectIsDiscord, selectIsMobile } from '../../selectors/app';
import { selectIsUserSubscribed } from '../../selectors/me';

const adBlockerPlayerStatuses = {
  [playerStatuses.connecting]: true,
  [playerStatuses.failed]: true,
};

function shouldShowPlayerForAdBlockerCheck(isUserSubscribed, playerStatus, hasAdBlocker) {
  if (isUserSubscribed || hasAdBlocker === false) {
    return false;
  }

  return !!adBlockerPlayerStatuses[playerStatus];
}

export function useShouldShowPlayer() {
  const { playerStore, appStore } = useStores();
  const routeProps = useRouteProps();
  const isMobile = useSelector(selectIsMobile);
  const isDiscord = useSelector(selectIsDiscord);
  const isUserSubscribed = useSelector(selectIsUserSubscribed);
  const playerStatus = playerStore?.playerStatus();
  const currentGuideItem = playerStore?.currentGuideItem();
  const hasAdBlocker = appStore?.hasAdBlocker();

  if (isMobile && routeProps.hidePlayerOnMobile) {
    return false;
  }

  return Boolean(
    playerStatus !== playerStatuses.idle ||
      currentGuideItem?.playableGuideId ||
      // Player should always show on Discord desktop
      (isDiscord && !isMobile) ||
      shouldShowPlayerForAdBlockerCheck(isUserSubscribed, playerStatus, hasAdBlocker),
  );
}
